// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Hwwr","footer":"styles_footer__2Antr","passCodeTooltip":"styles_passCodeTooltip__2zH-X"};